import { get_documents } from "@/code/axios";

let cache_built = false;
let message_cache = {};

function build_cache(response) {
  message_cache = {};
  for (const r of response) {
    message_cache[r.name] = r.text;
  }
  cache_built = true;
}

function initialize_cache() {
  if (cache_built) return Promise.resolve();
  return get_documents().then((r) => {
    build_cache(r);
    return Promise.resolve();
  });
}

export { initialize_cache };

function get_message(name) {
  if (!cache_built) return Promise.reject({ detail: "cache_not_initialized" });

  const value = message_cache ? message_cache[name] : undefined;
  if (value != undefined) {
    return Promise.resolve(value);
  } else {
    return Promise.reject({ detail: "document_not_found" });
  }
}

export { get_message };
